import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { Ps } from './services/ps.service';
import { PsContractTypeComboBox } from './views/psContractTypeComboBox.component';
import { PsSpecialtyComboBox } from './views/psSpecialtyComboBox.component';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { AgmCoreModule } from '@agm/core';
import router from './router';
import { ProviderSearch } from './providers/providerSearch.component';
import { ConnectureComponent } from './connecture/connecture.component';

@NgModule({
  declarations: [
        AppComponent,
        PsContractTypeComboBox,
        PsSpecialtyComboBox,
        ProviderSearch,
        ConnectureComponent
  ],
  imports: [
      BrowserModule,
      HttpClientModule,
      router,
      FormsModule,
      NgxPaginationModule,
      AgmCoreModule.forRoot({
          apiKey: 'AIzaSyBmCdWM9kV_uUR0oSHf0wDGoySJ7A-JovY',
          libraries: ['places']
      })
  ],
    providers: [
        Ps
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
